import { PersonalInfoDetailsAnswer, PracticePatient } from "@physiofit-digital/physiofit_types";
import { TFunction } from "i18next";
import { formatRecordDate, storedCalendarDay } from "../../welcome/utils/formatRecordDate";

type StoredPersonalInfo = PracticePatient["personalInfo"];

// Strict on purpose (PF-6134): the server decides who is the same person, so a difference it would forgive costs one
// question here, never a silent rename.
const comparableName = (value: unknown) =>
  typeof value === "string" ? value.normalize("NFC").trim().replace(/\s+/g, " ").toLocaleLowerCase("de") : "";

/** The calendar day of a stored date as the server's normalizeBirthday reads it, or "". */
export const calendarDay = (value: unknown) => storedCalendarDay(value) ?? "";

const overwrites = (stored: string, typed: string) => stored !== "" && stored !== typed;

/** True when the typed data would overwrite a stored name or birthday; filling an empty field is no change. */
export const changesStoredPerson = (stored: StoredPersonalInfo, typed: PersonalInfoDetailsAnswer) =>
  overwrites(comparableName(stored?.firstName), comparableName(typed.firstName)) ||
  overwrites(comparableName(stored?.lastName), comparableName(typed.lastName)) ||
  overwrites(calendarDay(stored?.birthday), calendarDay(typed.birthday));

/** "Maria Müller, geboren am 01.02.1980" for the question; a record without a name reads as in the chooser. */
export const storedPersonLabel = (stored: StoredPersonalInfo, t: TFunction) => {
  const name = [stored?.firstName, stored?.lastName].filter(Boolean).join(" ") || t("SMS_LOGIN_CHOOSER_UNNAMED");
  const date = formatRecordDate(stored?.birthday);
  return [name, date ? t("SMS_LOGIN_CHOOSER_BORN", { date }) : ""].filter(Boolean).join(", ");
};
